import $ from 'jquery';
import listService from 'ListService';
import constants from 'Constants.js';
import Immutable from 'immutable';

import { View } from 'backbone';

import formatTemplate from 'properties/main/form_instance.ejs';


class MainFormInstanceView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=radio]' : 'updateAttributes'
        };

        if (!this.model.get('formInstance')) {
            this.model.set('formInstance', 'new_instance', {silent: true});
        }
        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set( propName, propVal );
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        $('input[name=parentChild][value="'+this.model.get('parentChild')+'"]').prop('checked', true);
        
        this.delegateEvents();
        return this;
    }

}

export default MainFormInstanceView;
